import { FormLayout } from "@careinfo/layout";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import {
  createCustomerValidationForm,
  ICreateCustomer,
} from "../../utils/validationSchemas";
import CustomerForm from "./CustomerForm";

const CreateCustomer = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    control,
    clearErrors,
  } = useForm<ICreateCustomer>({
    resolver: yupResolver(createCustomerValidationForm),
  });
  const { handleCreate, isLoading } = props;

  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <CustomerForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
        control={control}
      />
    </FormLayout>
  );
};

export default CreateCustomer;
